import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { DocumentProcessorService } from 'src/proxy';

@Injectable({
  providedIn: 'root'
})
export class AccessControlService {

  private signedPunchesAccess = new BehaviorSubject<boolean>(false);
  public signedPunchesAccess$ = this.signedPunchesAccess.asObservable();

  constructor(private documentProcessor: DocumentProcessorService, private router: Router) { }

  checkSignedPunchesAccess(): void {
    this.documentProcessor.isSignedPunchesVisible().subscribe(response => {
      this.signedPunchesAccess.next(response);
    });
  }
}
